/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YesterdaySleepWrapUpResponseDto
 */
export interface YesterdaySleepWrapUpResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    available: boolean;
    /**
     * 
     * @type {Date}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    date: Date;
    /**
     * 
     * @type {boolean}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    wearableConnected: boolean;
    /**
     * 
     * @type {object}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    taskId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    title?: object | null;
    /**
     * 
     * @type {object}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    targetMinutes?: object | null;
    /**
     * 
     * @type {object}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    actualMinutes?: object | null;
    /**
     * 
     * @type {string}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    source?: YesterdaySleepWrapUpResponseDtoSourceEnum | null;
    /**
     * 
     * @type {object}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    question?: object | null;
    /**
     * 
     * @type {object}
     * @memberof YesterdaySleepWrapUpResponseDto
     */
    isGoalMet?: object | null;
}


/**
 * @export
 */
export const YesterdaySleepWrapUpResponseDtoSourceEnum = {
    Wearable: 'wearable',
    Manual: 'manual'
} as const;
export type YesterdaySleepWrapUpResponseDtoSourceEnum = typeof YesterdaySleepWrapUpResponseDtoSourceEnum[keyof typeof YesterdaySleepWrapUpResponseDtoSourceEnum];


/**
 * Check if a given object implements the YesterdaySleepWrapUpResponseDto interface.
 */
export function instanceOfYesterdaySleepWrapUpResponseDto(value: object): value is YesterdaySleepWrapUpResponseDto {
    if (!('available' in value) || value['available'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('wearableConnected' in value) || value['wearableConnected'] === undefined) return false;
    return true;
}

export function YesterdaySleepWrapUpResponseDtoFromJSON(json: any): YesterdaySleepWrapUpResponseDto {
    return YesterdaySleepWrapUpResponseDtoFromJSONTyped(json, false);
}

export function YesterdaySleepWrapUpResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): YesterdaySleepWrapUpResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'],
        'date': (new Date(json['date'])),
        'wearableConnected': json['wearableConnected'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'title': json['title'] == null ? undefined : json['title'],
        'targetMinutes': json['targetMinutes'] == null ? undefined : json['targetMinutes'],
        'actualMinutes': json['actualMinutes'] == null ? undefined : json['actualMinutes'],
        'source': json['source'] == null ? undefined : json['source'],
        'question': json['question'] == null ? undefined : json['question'],
        'isGoalMet': json['isGoalMet'] == null ? undefined : json['isGoalMet'],
    };
}

export function YesterdaySleepWrapUpResponseDtoToJSON(json: any): YesterdaySleepWrapUpResponseDto {
    return YesterdaySleepWrapUpResponseDtoToJSONTyped(json, false);
}

export function YesterdaySleepWrapUpResponseDtoToJSONTyped(value?: YesterdaySleepWrapUpResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'wearableConnected': value['wearableConnected'],
        'taskId': value['taskId'],
        'title': value['title'],
        'targetMinutes': value['targetMinutes'],
        'actualMinutes': value['actualMinutes'],
        'source': value['source'],
        'question': value['question'],
        'isGoalMet': value['isGoalMet'],
    };
}

